// gatsby-browser.js
require('prismjs/themes/prism-coy.css')
require('antd/dist/antd.css')
require(`katex/dist/katex.min.css`)
